module.exports = __webpack_public_path__ + "img/home.795fb7e0.png";